module.exports = __webpack_public_path__ + "static/media/ic_delivery_white.7fc3d6f6.svg";